import { render, staticRenderFns } from "./m-paiban-task-list.vue?vue&type=template&id=044b08ac&scoped=true&"
import script from "./m-paiban-task-list.vue?vue&type=script&lang=ts&setup=true&"
export * from "./m-paiban-task-list.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./m-paiban-task-list.vue?vue&type=style&index=0&id=044b08ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044b08ac",
  null
  
)

export default component.exports